// extracted by mini-css-extract-plugin
export default {"component":"Banner_component__7kaFq"};